import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCtlZt5lI_r8Jqr4oKZ9KPCKTDbT2WGCAA",
  authDomain: "my-sales-website.firebaseapp.com",
  projectId: "my-sales-website",
  storageBucket: "my-sales-website.firebasestorage.app",
  messagingSenderId: "826394974605",
  appId: "1:826394974605:web:94cece34e99acb686885c4",
  measurementId: "G-312CMDY86T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

export { db, auth };
